"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFiles = validateFiles;
exports.detectCadTool = detectCadTool;
exports.buildProjectDefinition = buildProjectDefinition;
exports.parseNetlist = parseNetlist;
const ProjectFileCollectionValidator_1 = require("./ProjectFileCollectionValidator");
const validation_1 = require("./validation");
const kicadNetlistValidation_1 = require("./Kicad/kicadNetlistValidation");
const PCAD_1 = require("./PCAD");
const OrCAD_1 = require("./OrCAD");
const Allegro_1 = require("./Allegro");
const Util_1 = require("./Util");
async function validateFiles(files) {
    const results = await Promise.all(files.map(async ({ name, blob }) => {
        const validationResult = await (0, validation_1.validateFile)(name, blob);
        return { filename: name, blob, validationResult };
    }));
    return {
        validFiles: results.filter((r) => r.validationResult.isValid),
        invalidFiles: results.filter((r) => !r.validationResult.isValid),
    };
}
function detectCadTool(validFiles, declaredTool) {
    const cadTools = new Set();
    for (const { validationResult } of validFiles) {
        if (!validationResult.isValid || !ProjectFileCollectionValidator_1.TYPE_DETECTION_SEMANTIC_TYPES.has(validationResult.data.semanticType)) {
            continue;
        }
        if (validationResult.data.fileFormat.cadTool) {
            cadTools.add(validationResult.data.fileFormat.cadTool);
        }
    }
    if (cadTools.size === 0) {
        throw new Error('Could not detect CAD tool from uploaded files');
    }
    if (cadTools.size > 1) {
        if (declaredTool !== undefined && cadTools.has(declaredTool)) {
            return declaredTool;
        }
        throw new Error(`Multiple CAD tools detected: ${Array.from(cadTools).join(', ')}`);
    }
    return Array.from(cadTools)[0];
}
function buildProjectDefinition(validFiles, cadTool, getEntryName) {
    const projectDefinition = {
        type: cadTool,
        boards: {},
        schematics: {},
        other: {},
    };
    for (const { filename, blob, validationResult } of validFiles) {
        if (!validationResult.isValid) {
            continue;
        }
        const entryName = getEntryName ? getEntryName(filename) : filename;
        const semanticType = validationResult.data.semanticType;
        const fileDescriptor = {
            type: semanticType,
            originalFileName: entryName,
            contents: blob,
            validationResult,
        };
        if (semanticType === 'board') {
            projectDefinition.boards[filename] = fileDescriptor;
        }
        else if (semanticType === 'schematic') {
            projectDefinition.schematics[entryName] = fileDescriptor;
        }
        else {
            projectDefinition.other[entryName] = fileDescriptor;
        }
    }
    return projectDefinition;
}
async function parseNetlist(filename, netlistBytes) {
    const utf8Content = new TextDecoder('utf-8').decode(netlistBytes);
    const kicadResult = (0, kicadNetlistValidation_1.validateKicadNetlist)(filename, utf8Content);
    const kicadSchematic = (0, kicadNetlistValidation_1.getSchematicFromResult)(kicadResult);
    if (kicadSchematic) {
        return kicadSchematic;
    }
    try {
        const pcadContent = (0, Util_1.decodeWindows1252Clean)(netlistBytes);
        if ((0, PCAD_1.validatePcadFile)(filename, pcadContent).isValid) {
            const pcadResult = (0, PCAD_1.parsePcadNetlist)(pcadContent);
            if (pcadResult.schematic) {
                return pcadResult.schematic;
            }
        }
    }
    catch {
    }
    const orcadResult = await (0, OrCAD_1.validateOrCADXFile)(filename, utf8Content);
    if (orcadResult.isValid) {
        const orcadParseResult = (0, OrCAD_1.parseOrCADNetlist)(utf8Content);
        const orcadSchematic = (0, OrCAD_1.getSchematicFromOrcadParseResult)(orcadParseResult);
        if (orcadSchematic) {
            return orcadSchematic.schematic;
        }
    }
    const allegroResult = (0, Allegro_1.validateAllegroFile)(filename, utf8Content);
    if (allegroResult.isValid && allegroResult.data?.semanticType === 'netlist') {
        const parseResult = allegroResult.data.metadata[Allegro_1.AllegroProjectMetadataKey.ParsedNetlist];
        const allegroSchematic = parseResult ? (0, Allegro_1.getSchematicFromAllegroParseResult)(parseResult) : undefined;
        if (allegroSchematic) {
            return allegroSchematic.schematic;
        }
    }
    return undefined;
}
//# sourceMappingURL=project-pipeline.js.map